import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { withDefaults, ref, onMounted } from 'vue';
import {
  BaseDialog,
  BaseTextContent,
  BaseButton,
  XrkMessage
} from 'xrk-components';
import {
  basicInformation,
  makeOutAnInvoice
} from '@V/invoice/src/data-source/apis';
import {
  BasicInformationData,
  MakeOutAnInvoiceParams,
  NotInvoicedListParams
} from '@V/invoice/src/data-source/types';
import InvoiceOpenDialogInfo from './invoice-open-dialog-info.vue';
import InvoiceOpenDialogAddress from './invoice-open-dialog-address.vue';
import InvoiceOpenDialogContent from './invoice-open-dialog-content.vue';
import InvoiceOpenDialogList from './invoice-open-dialog-list.vue';
import InvoiceOpenDialogDemand from './invoice-open-dialog-demand.vue';
import appStore from '@/store';
import { storeToRefs } from 'pinia';

type FormData = MakeOutAnInvoiceParams & NotInvoicedListParams;


export default /*#__PURE__*/_defineComponent({
  __name: 'invoice-open-dialog',
  props: {
    remove: { type: Function, default() {
      return () => {
        console.log('remove');
      };
    } }
  },
  emits: ["success"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

const { info: userInfo } = storeToRefs(appStore.useUserStoreSetup);

const isConfirm = ref(false); // 确认禁止内容操作
const infoRef = ref();
const contentRef = ref();
const addressList = ref<BasicInformationData['addressList']>([]);
const baseInfo = ref<BasicInformationData['baseInfo']>({
  entpName: '',
  entpCertNo: '',
  phone: '',
  bankName: '',
  openBankNumber: '',
  companyBusinessAddress: '',
  demand: ''
});
// 提交数据与列表搜索数据放一起了
const formData = ref<FormData>({
  theSellerId: null,
  itemId: null,
  invoiceType: null,
  stateType: null,
  openOrderIds: [],
  addressId: null,
  userDefinedOrderType: null,
  auditSign: 1 // 写死
});

const onCancel = () => {
  if (isConfirm.value) {
    isConfirm.value = false;
  } else {
    props.remove();
  }
};
const onConfirm = async () => {
  if (!isConfirm.value) {
    try {
      await infoRef.value.validate();
    } catch (e) {
      XrkMessage.error('请到企业开票维护，完善企业开票信息，谢谢');
      return;
    }
    await Promise.all([infoRef.value.validate(), contentRef.value.validate()]);
    if (!formData.value.openOrderIds.length) {
      XrkMessage.error('请选择订单');
      return;
    }
    isConfirm.value = true;
  } else {
    await makeOutAnInvoice({
      ...formData.value,
      isBaseAsp: userInfo.value.isBaseAsp || 0
    });
    emits('success');
    props.remove();
  }
};
onMounted(async () => {
  const { data } = await basicInformation();
  addressList.value = data.addressList;
  baseInfo.value = data.baseInfo;
  formData.value.demand = baseInfo.value.demand;
  // 赋值开票地址(第一个)默认项
  formData.value.addressId =
    data.addressList.find(item => item.isDefault)?.id || null;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(BaseDialog), {
    width: "950px",
    class: "form-dialog form-dialog--label120 form-dialog-invoice-custom",
    title: "申请开票",
    "model-value": true,
    "close-on-press-escape": true,
    "close-on-click-modal": false
  }, {
    footer: _withCtx(() => [
      _createVNode(_unref(BaseButton), {
        type: "default",
        onClick: onCancel
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(isConfirm.value ? '上一步' : '取消'), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(BaseButton), { onClick: onConfirm }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(isConfirm.value ? '确认提交' : '下一步'), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(BaseTextContent), null, {
        default: _withCtx(() => [
          _createVNode(InvoiceOpenDialogInfo, {
            ref_key: "infoRef",
            ref: infoRef,
            modelValue: formData.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData).value = $event)),
            baseInfo: baseInfo.value,
            disabled: isConfirm.value
          }, null, 8, ["modelValue", "baseInfo", "disabled"]),
          _createVNode(InvoiceOpenDialogAddress, {
            modelValue: addressList.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((addressList).value = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(InvoiceOpenDialogContent, {
            ref_key: "contentRef",
            ref: contentRef,
            modelValue: formData.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData).value = $event)),
            disabled: isConfirm.value
          }, null, 8, ["modelValue", "disabled"]),
          _withDirectives(_createVNode(InvoiceOpenDialogDemand, {
            modelValue: formData.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData).value = $event))
          }, null, 8, ["modelValue"]), [
            [_vShow, isConfirm.value]
          ]),
          _createVNode(InvoiceOpenDialogList, {
            disabled: isConfirm.value,
            contentRef: contentRef.value,
            modelValue: formData.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData).value = $event))
          }, null, 8, ["disabled", "contentRef", "modelValue"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})